import { render, staticRenderFns } from "./Setup_Aircrafts.vue?vue&type=template&id=295207c0&scoped=true&"
import script from "./Setup_Aircrafts.vue?vue&type=script&lang=js&"
export * from "./Setup_Aircrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295207c0",
  null
  
)

export default component.exports